import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  style: {"enable-background":"new 0 0 16 16"},
  "xml:space": "preserve",
  xmlns: "http://www.w3.org/2000/svg",
  width: "16",
  height: "16",
  fill: "currentColor",
  class: "qi-1019"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("path", { d: "M15.513 6.16c-.115-.198-.721-1.202-1.963-1.611 0 0-.507-.172-1.08-.172-1.56 0-3.659 1.565-4.47 2.673-.248-.287-2.378-2.687-4.47-2.673-.561.004-1.06.165-1.06.165C1.219 4.947.609 5.949.487 6.16a3.715 3.715 0 0 0 0 3.68c.115.199.72 1.199 1.959 1.61 0 0 .509.173 1.085.173 1.541 0 3.646-1.578 4.47-2.694.825 1.116 2.931 2.694 4.471 2.694.597 0 1.121-.185 1.121-.185 1.208-.415 1.8-1.388 1.922-1.598.122-.215.485-.893.485-1.84 0-.948-.363-1.627-.487-1.84z" }, null, -1)
const _hoisted_3 = [
  _hoisted_2
]

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _hoisted_3))
}
export default { render: render }